<template>
  <div>
    <v-table
      url="/api/v1/blacklistUsername"
      :attributes="[
        {
          attribute: 'name',
          name: 'Name',
          type: 'InputCell',
          message: 'Der Name wurde gespeichert',
          url: 'update_url'
        },
        {
          attribute: 'created_by.name',
          name: 'Erstellt von'
        },
        {
          attribute: 'created_at',
          name: 'Erstellt um',
          type: 'DateTimeCell'
        },
        {
          attribute: 'updated_by.name',
          name: 'Updated von'
        },
        {
          attribute: 'updated_at',
          name: 'Updated um',
          type: 'DateTimeCell'
        },
        {
          notification: 'Der name wurde aus der Blacklist gelöscht',
          name: 'Entfernen',
          type: 'DeleteCell',
          label: 'Löschen',
          sortable: false
        }
      ]"
    >
      <div slot="title">
        <h4>Namen bearbeiten</h4>
      </div>
    </v-table>
    <resource
      resource="blacklistUsername"
      resourceName="Blacklist"
      :attributes="attributes"
      @resource-persisted="$bus.$emit('refresh-table')"
    >
      <div slot="title">
        <h4>Namen hinzufügen</h4>
      </div>
    </resource>
  </div>
</template>

<script lang="babel">
export default {
  computed: {
    attributes() {
      return [
        {
          name: 'names',
          buttonText: '+Name',
          type: 'MultiInputSelector'
        }
      ];
    }
  }
};
</script>
